var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from "axios";
import { NATIVE_RPC_METHODS } from "../mobile/events.enum";
var HttpClient = /** @class */ (function () {
    function HttpClient() {
        var _this = this;
        this._accessToken = "";
        this._getAccessTryCount = 1;
        this._refreshAccessTryCount = 1;
        this._unauthorizedCount = 1;
        this._bodyMethods = ["POST", "PUT", "PATCH"];
        this._reqURL = function (url, baseURL) {
            return "".concat(baseURL || "", "/").concat(url);
        };
        this._shellLog = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.log.apply(console, __spreadArray(["WEB SHELL:"], args, false));
        };
        this._logCalling = function (callTarget) {
            _this._shellLog("".concat(callTarget, " - calling..."));
        };
        this._logCallResult = function (callTarget, result) {
            var resultSubstr = result ? "result\n".concat(result) : "finished";
            _this._shellLog("".concat(callTarget, " - ").concat(resultSubstr));
        };
        this._logCallFail = function (callTarget, attemptCount) {
            var attemptSubstr = attemptCount ? " (attempt #".concat(_this._getAccessTryCount, ")") : "";
            _this._shellLog("".concat(callTarget, " - failed").concat(attemptSubstr));
        };
        this._logServerError = function (config, statusCode) {
            _this._shellLog("".concat(statusCode, " ERROR on ").concat(_this._reqURL(config.url, config.baseURL)));
        };
        this._logRetry = function (retryTarget) {
            _this._shellLog("".concat(retryTarget, " - trying again"));
        };
        this._initializeClients = function () {
            _this._httpClient = axios.create();
        };
        this._increaseGetAccessTryCount = function () {
            _this._getAccessTryCount++;
        };
        this._increaseRefreshAccessTryCount = function () {
            _this._refreshAccessTryCount++;
        };
        this._increaseUnauthorizedCount = function () {
            _this._unauthorizedCount++;
        };
        this._resetGetAccessTryCount = function () {
            if (_this._getAccessTryCount !== 1) {
                _this._getAccessTryCount = 1;
            }
        };
        this._resetRefreshAccessTryCount = function () {
            if (_this._refreshAccessTryCount !== 1) {
                _this._refreshAccessTryCount = 1;
            }
        };
        this._resetUnauthorizedCount = function () {
            if (_this._unauthorizedCount !== 1) {
                _this._unauthorizedCount = 1;
            }
        };
        this._isUnauthorizedError = function (error) {
            var _a;
            if (_this._unauthorizedCount > 2) {
                _this._resetUnauthorizedCount();
                return false;
            }
            return ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401;
        };
        this._refreshToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var method, token, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        method = NATIVE_RPC_METHODS.REFRESH_TOKENS;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 7]);
                        this._accessToken = "";
                        this._logCalling(method);
                        return [4 /*yield*/, window.$RPC.request(method, {})];
                    case 2:
                        token = (_a.sent()).token;
                        this._resetRefreshAccessTryCount();
                        this._logCallResult(method, token);
                        this._accessToken = token;
                        return [3 /*break*/, 7];
                    case 3:
                        error_1 = _a.sent();
                        this._logCallFail(method, this._refreshAccessTryCount);
                        if (!(this._refreshAccessTryCount < 2)) return [3 /*break*/, 5];
                        this._logRetry(method);
                        this._increaseRefreshAccessTryCount();
                        return [4 /*yield*/, this._refreshToken()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this._resetRefreshAccessTryCount();
                        throw error_1;
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        this._setToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var method, token, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this._accessToken) return [3 /*break*/, 8];
                        method = NATIVE_RPC_METHODS.GET_ACCESS_TOKEN;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 8]);
                        this._logCalling(method);
                        return [4 /*yield*/, window.$RPC.request(method, {})];
                    case 2:
                        token = (_a.sent()).token;
                        this._resetGetAccessTryCount();
                        this._logCallResult(method, token);
                        this._accessToken = token;
                        return [3 /*break*/, 8];
                    case 3:
                        error_2 = _a.sent();
                        this._logCallFail(method, this._getAccessTryCount);
                        if (!(this._getAccessTryCount < 5)) return [3 /*break*/, 5];
                        this._logRetry(method);
                        this._increaseGetAccessTryCount();
                        return [4 /*yield*/, this._setToken()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        this._resetGetAccessTryCount();
                        return [4 /*yield*/, this._refreshToken()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        this._reqRetry = function (_a) {
            var _b;
            var method = _a.method, data = _a.data, url = _a.url, opts = __rest(_a, ["method", "data", "url"]);
            _this._logRetry(_this._reqURL(url, opts.baseURL));
            var methodArgs = [url, opts];
            if (_this._bodyMethods.includes(method.toUpperCase())) {
                methodArgs.splice(1, 0, data);
            }
            return (_b = _this._httpClient)[method.toLowerCase()].apply(_b, methodArgs);
        };
        this._decorateRequest = function (request) {
            var result = __assign({}, request);
            result.headers = __assign(__assign({}, result.headers), { Authorization: "Bearer ".concat(_this._accessToken) });
            return result;
        };
        this._initializeClients();
        this._httpClient.interceptors.request.use(function (request) { return __awaiter(_this, void 0, void 0, function () {
            var decoratedRequest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._setToken()];
                    case 1:
                        _a.sent();
                        decoratedRequest = this._decorateRequest(request);
                        return [2 /*return*/, decoratedRequest];
                }
            });
        }); }, function (error) {
            _this._shellLog("_setToken() failed, request rejected");
            return Promise.reject(error);
        });
        this._httpClient.interceptors.response.use(function (response) {
            _this._resetUnauthorizedCount();
            return response;
        }, function (error) { return __awaiter(_this, void 0, void 0, function () {
            var decoratedRequest;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this._isUnauthorizedError(error)) return [3 /*break*/, 2];
                        this._logServerError(error === null || error === void 0 ? void 0 : error.config, (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status);
                        this._increaseUnauthorizedCount();
                        return [4 /*yield*/, this._refreshToken()];
                    case 1:
                        _b.sent();
                        decoratedRequest = this._decorateRequest(error === null || error === void 0 ? void 0 : error.config);
                        return [2 /*return*/, this._reqRetry(decoratedRequest)];
                    case 2: return [2 /*return*/, Promise.reject(error)];
                }
            });
        }); });
    }
    HttpClient.prototype.get = function (url, options) {
        if (options === void 0) { options = {}; }
        return this._httpClient.get(url, options);
    };
    HttpClient.prototype.post = function (url, data, options) {
        if (options === void 0) { options = {}; }
        return this._httpClient.post(url, data, options);
    };
    HttpClient.prototype.put = function (url, data, options) {
        if (options === void 0) { options = {}; }
        return this._httpClient.put(url, data, options);
    };
    HttpClient.prototype.delete = function (url, options) {
        if (options === void 0) { options = {}; }
        return this._httpClient.delete(url, options);
    };
    HttpClient.prototype.patch = function (url, data, options) {
        if (options === void 0) { options = {}; }
        return this._httpClient.patch(url, data, options);
    };
    HttpClient.prototype.options = function (url, options) {
        if (options === void 0) { options = {}; }
        return this._httpClient.options(url, options);
    };
    HttpClient.prototype.head = function (url, options) {
        if (options === void 0) { options = {}; }
        return this._httpClient.head(url, options);
    };
    return HttpClient;
}());
export { HttpClient };
export var httpClient = new HttpClient();
